import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WeightUnitsEnum } from 'src/app/core/enums/weight-units.enum';
import convertWeight from 'src/app/core/helpers/convert-weight';
import { PickingZone } from 'src/app/location/models/picking-zone.interface';
import { LocationService } from 'src/app/location/services/location.service';

@Component({
  selector: 'app-create-picking-zone-modal',
  templateUrl: './create-picking-zone-modal.component.html',
})
export class CreatePickingZoneModalComponent implements OnInit {
  @Output() onApprove = new EventEmitter<PickingZone>();

  form: FormGroup = this.fb.group({
    name: [null, Validators.required],
    locationSize: [null, Validators.required],
    priority: [null, [Validators.required, Validators.min(0)]],
    reservePercentage: [null, [Validators.required, Validators.min(0), Validators.max(100)]],
    maxPackageWeight: [null, [Validators.min(0)]],
  });

  constructor(
    public dialogRef: MatDialogRef<CreatePickingZoneModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: PickingZone,
    public locationService: LocationService,
  ) {}

  ngOnInit() {
    if (this.data) {
      this.form.patchValue({
        ...this.data,
        locationSize: this.data?.locationSize?.id,
        maxPackageWeight: convertWeight(this.data.maxPackageWeight, WeightUnitsEnum.G, WeightUnitsEnum.KG),
      });
    }
  }

  approve(): void {
    if (this.form.valid) {
      const maxPackageWeight = this.form.value.maxPackageWeight;
      const payload: any = {
        ...this.form.value,
        maxPackageWeight: maxPackageWeight && maxPackageWeight > 0 ? convertWeight(maxPackageWeight, WeightUnitsEnum.KG, WeightUnitsEnum.G) : null,
      };

      this.onApprove.emit(payload);
      this.dialogRef.close();
    }
  }

  reject(): void {
    this.dialogRef.close();
  }
}
